import React from "react";
import PropTypes from "prop-types";
import { IoInformationCircle } from "react-icons/io5";
import { Tooltip as ReactTooltip } from "react-tooltip";

const InformationalTooltip = ({ dark, content, id }) => (
  <div
    className="informational-tooltip-container"
    id={id}
    data-tooltip-content={content}
    data-tooltip-variant={dark ? "dark" : "light"}
    data-html
    data-place="right"
  >
    <span>
      <IoInformationCircle />
    </span>
    <ReactTooltip
      anchorId={id}
      className={`custom-tooltip ${dark ? "dark" : "light"}`}
      place="right"
      type={dark ? "dark" : "light"}
      effect="solid"
      globalEventOff="click"
    />
  </div>
);

InformationalTooltip.propTypes = {
  dark: PropTypes.bool,
  content: PropTypes.string,
  id: PropTypes.string
};

InformationalTooltip.defaultProps = {
  dark: false,
  content: ""
};

export default InformationalTooltip;
